<section class="container-fluid">
    <header class="row pt-3">
        <div class="col-12 d-flex justify-content-between">
            <div>
                <h4 class="text-white">Crear Pago</h4>
                <h6 class="text-secondary"></h6>
            </div>
            <!-- <div>
                <button class="me-1 btn btn-outline-light" routerLink="./../list" ><i class="fa-solid fa-right-from-bracket" aria-hidden="true"></i> Volver al listado de proyectos</button>
                <button *ngIf="step > 1"  class="mx-2 btn btn-outline-light "(click)="step=step-1"><i class="fa fa-arrow-left" aria-hidden="true"></i> Volver a la etapa anterior</button>
                <button *ngIf="step < 4"  class="ms-1 btn btn-outline-light" (click)="step=step+1" > <i class="fa fa-arrow-right" aria-hidden="true"></i> Siguiente etapa</button>
            </div>            -->
        </div>
    </header>

</section>

<section class="container-fluid shadow pt-3 pb-2 text-white backgroundTable mt-3 " style="min-height:750px !important;">
    <div class="container-fluid d-flex justify-content-between align-items-center">
        <div class="componente-importantes text-start px-5 mt-3" style="min-height:750px;">
            <form action="" method="post" (submit)="formSubmit()" [formGroup]="createPayForm">

                    <div class="col">
                        <div form-group px-3 pb-3>

                            <div form-group px-3 pb-3>
                                <label for="formControlInput" class="form-label mt-5">Descripción</label>
                                <input type="text" placeholder="Ingrese descripción" id="title" formControlName="title"
                                class="form-control custom-outline-input date">
    
                            </div>

                            <label for="formControlInput" class="form-label mt-5">Tipo de moneda</label>
                            <select class="custom-outline-input date mt-3 form-select mt-3" id="project_attachments_id"
                                formControlName="project_attachments_id" aria-label="Default select">
                                <option [selected]="true" value="0">Seleccione moneda</option>
                                <option *ngFor="let item of listMoney" [ngValue]="item">
                                    {{item.name}}
                                </option>
                            </select>
                        </div>

                        <div form-group px-3 pb-3>
                            <label for="formControlInput" class="form-label mt-5">Monto</label>
                            <input type="text" placeholder="Ingrese monto" id="pay_amount" formControlName="pay_amount"
                            class="form-control custom-outline-input date">

                        </div>
                    

                        <div form-group px-3 pb-3>
                            <label for="formControlInput" class="form-label mt-5">Porcentaje</label>
                            <input type="text" placeholder="Ingrese porcentaje" id="amount_percent" formControlName="amount_percent"
                            class="form-control custom-outline-input date">

                        </div>
                    

                        <div form-group px-3 pb-3>
                            <label for="formControlInput" class="form-label mt-5">Fecha Programada</label>
                            <input type="date" class="form-control custom-outline-input date" id="scheduled_date"
                                formControlName="scheduled_date">
                        </div>

                        <div form-group px-3 pb-3>

                            <label for="formControlInput" class="form-label mt-5">Anexo de contrato</label>
                            <select class="custom-outline-input form-select mt-3" id="money_type_id"
                                formControlName="money_type_id" aria-label="Default select">
                                <option [selected]="true" value="0">Seleccionar Anexo</option>
                                <option *ngFor="let item of listAnexo" [ngValue]="item">
                                    {{item.name}}
                                </option>
                            </select>
                        </div>
                    
                
                    
                        <div class="form-group d-flex justify-content-sm-end mt-4">                      
                            <div>
                                <button class="btn btn-outline-success me-3" style="font-size: 15px;"> <i _ngcontent-xfk-c127="" class="fa-solid fa-floppy-disk m-1"></i> Guardar Usuario</button>
                            </div>

                       


                     </div>
                    <!-- <div class="col-12 col-lg-6 col-xxl-auto mx-2 d-flex justify-content-center justify-content-lg-start">
                    <div>
                    <button class="mx-2 btn btn-outline-light"> <i class="fa fa-floppy-disk"
                        aria-hidden="true"></i> Guardar Usuario</button>
                    </div>
                </div> -->

                </div>
            </form>

         
        </div>

        
    </div>
    
</section>


<router-outlet></router-outlet>